<template>
  <div class="contain">
    <!-- 第一部分 -->
    <div class="searchbox">
      <el-row :gutter="20">
        <el-form :inline="true" :model="searchInput">
          <el-form-item>
            <el-input v-model="searchInput.projectName"   class="input-placeholder-sm" placeholder="项目名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchInput.customerName"  class="input-placeholder-sm" placeholder="客户名称"  style="width:130px"  clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker value-format="yyyy-MM-dd"  v-model="searchInput.startTime" type="date" style="width:130px" 
              placeholder="起始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker value-format="yyyy-MM-dd"   v-model="searchInput.endTime" type="date" placeholder="结束时间" style="width:130px" >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 10px" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 0px;width:130px" @click="queryUnPaidProject" plain>查询未结算项目</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 0px;width:150px" @click="checkProject" plain  :loading="loading">统计未结算项目</el-button>
          </el-form-item>
        
        </el-form>
      </el-row>
    </div>
    <!-- 第二部分 -->
    <div class="tableBox">
      <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#f7f7f7' }"
        @row-dblclick="rowDblclick" @row-contextmenu="openMenu" :row-style="rowStyle" :height="height + 'px'">
        <el-table-column prop="id" label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.row.id }} </span>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" align="center" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.projectName }} </span>
          </template>
        </el-table-column>
        <el-table-column label="客户" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.customerName }} </span>
          </template>
        </el-table-column>
        <el-table-column label="立项日期" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.projectApprovalTime }} </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="预期结项日期" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.conclusionTime }} </span>
          </template>
        </el-table-column>
        <el-table-column label="实际结项日期" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.actualConclusionTime !== null">{{ scope.row.actualConclusionTime | dataFormat }}
            </span>
            <span v-if="scope.row.actualConclusionTime === null">未完成</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <a :href="scope.row.speed" target="_blank"><button v-if="scope.row.speed">计划</button></a>
            <div v-if="!scope.row.speed">暂无计划</div>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="进度" align="center">
          <template slot-scope="scope">
            <span>Finish({{ scope.row.totalNodesCount || 0 }}/{{ scope.row.finishNodesCount || 0 }})</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.remark }} </span>
          </template>
        </el-table-column>
        <el-table-column label="项目金额" align="center">
          <template slot-scope="scope">
            <span>{{ formatMoney(scope.row.projectAmount) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已付款" align="center">
          <template slot-scope="scope">
            <span style="color:#00B42A;">{{ formatMoney(scope.row.checkPaidFee) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="未付款" align="center">
          <template slot-scope="scope">
            <span style="color:#F53F3F;">{{ formatMoney(scope.row.checkUnPaidFee) }}</span>
          </template>
        </el-table-column>
     
        <el-table-column label="结算状态" align="center">
        <template slot-scope="scope">
          <span :style="scope.row.checkPaidStatus === 1 ? 'color:#00B42A;' : 'color:#F53F3F;'">
            {{ scope.row.checkPaidStatus === 1 ? '已结清' : '未结清' }}
          </span>
        </template>
      </el-table-column>

      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.currPage" :page-sizes="[50, 100, 300]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 右击菜单 -->
    <div v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <div class="cusBox" @click="changeColor(1, '#C43C57')">紧急项目</div>
      <div class="cusBox" @click="changeColor(2, '#63B8FF')">开发中</div>
      <div class="cusBox" @click="changeColor(3, '')">长期维护</div>
      <div class="cusBox" @click="changeColor(4, '#a3a3a6')">挂起</div>
      <div class="cusBox" @click="changeColor(5, '#008B00')">待收款</div>
      <div class="cusBox" @click="changeColor(6, '#7FFF00')">已收款未结清</div>
      <div class="cusBox">
        <div style="margin-bottom: 10px">单元格标记</div>
        <div style="display: flex">
          <div class="color-box" style="background-color: #fc3d39" @click="changeColor1('#fc3d39')"></div>
          <div class="color-box" style="background-color: #f7a550" @click="changeColor1('#f7a550')"></div>
          <div class="color-box" style="background-color: #f3cd56" @click="changeColor1('#f3cd56')"></div>
          <div class="color-box" style="background-color: #70ca57" @click="changeColor1('#70ca57')"></div>
          <div class="color-box" style="background-color: #63b8ff" @click="changeColor1('#63B8FF')"></div>
          <div class="color-box" style="background-color: #cf8bdf" @click="changeColor1('#cf8bdf')"></div>
          <div class="color-box" style="background-color: #a3a3a6" @click="changeColor1('#a3a3a6')"></div>
        </div>
      </div>
      <div class="cusBox" @click="changeColor1('')">取消标记</div>
    </div>

    <!-- 大弹窗 -->
    <el-dialog title="项目详情 " :visible.sync="dialogFormVisible"  width="65%">
      <div class="tabbox flex justify-around">
        <div @click="changeTap" :data-index="index" class="onetab"
          :class="index == activeIndex ? 'activebg' : 'tabcolor'" v-for="(item, index) in tabList" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="basicBox" v-if="activeIndex == '0'">
        <div class="onebasic">
          <el-row>
            <el-col :span="8">
              <div>客户姓名：{{ basicInfor.customerName }}</div>
            </el-col>
            <el-col :span="8">
              <div>联系人：{{ basicInfor.contact }}</div>
            </el-col>
            <el-col :span="8">
              <div>联系号码：{{ basicInfor.phone }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div>客户联系地址：{{ basicInfor.address }}</div>
            </el-col>
            <el-col :span="8">
              <div>商务：{{ basicInfor.businessDirectorName }}</div>
            </el-col>
            <el-col :span="8">
              <div>税号：{{ basicInfor.dutyNo }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="onebasic">
          <el-row>
            <el-col :span="8">
              <div>
                项目名称：<span style="color: red">{{
                  basicInfor.projectName
                }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div>项目负责人：{{ basicInfor.departmentLeaderName }}</div>
            </el-col>
            <el-col :span="8">
              <div>所属部门：{{ basicInfor.departmentName }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div>项目编号：{{ basicInfor.projectNo }}</div>
            </el-col>
            <el-col :span="8">
              <div>工期：{{ basicInfor.pprojectTime }}</div>
            </el-col>
            <el-col :span="8">
              <div>状态：{{ basicInfor.projectStatus }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="onebasic">
          <el-row>
            <el-col :span="8">
              <div>
                立项日期：{{ basicInfor.projectApprovalTime | dataFormat }}
              </div>
            </el-col>
            <el-col :span="8">
              <div v-if="basicInfor.actualConclusionTime">
                实际结项日期：{{ basicInfor.actualConclusionTime | dataFormat }}
              </div>
              <div v-else>实际结项日期：</div>
            </el-col>
            <el-col :span="8">
              <div></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div>备注：{{ basicInfor.remark }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="pointBox" v-if="activeIndex == '1'">
        <div class="onebasic">
          <el-row>
            <el-col :span="8">
              <div>
                项目名称：<span style="color: red">{{
                  basicInfor.projectName
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div>
                立项日期：{{ basicInfor.projectApprovalTime | dataFormat }}
              </div>
            </el-col>
            <el-col :span="8">
              <div>结束日期：{{ basicInfor.conclusionTime | dataFormat }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="process">
          <el-button type="primary" style="
              display: block;
              margin-right: auto;
              width: 100px;
              margin-left: 20px;
              margin-top: 20px;
            ">项目历程</el-button>
          <!-- 步骤条 -->
          <div class="projectProcess" style="padding-left: 20px">
            <el-steps direction="vertical" :active="activenum" active-color="#66b1ff" finish-icon="#66b1ff"
              active-icon="warning">
              <el-step :title="item.expectFinishTime" :description="item.nodeName + item.nodeLeaderName + item.leaderRemark
                " v-for="(item, index) in stepsList" :key="index">
                <template slot="description">
                  <span>{{ item.nodeName }}<br />{{ item.nodeLeaderName }}<br />{{
                    item.leaderRemark
                  }}</span>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>
      </div>
      <div class="fileBox" v-if="activeIndex == '2'">
        <el-button type="primary" style="
            display: block;
            margin-right: auto;
            width: 100px;
            margin-left: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          ">项目附件</el-button>
        <el-table :data="fileData" border style="width: 95%; margin: 0 auto" highlight-current-row
          :header-cell-style="{ background: '#f7f7f7' }">
          <el-table-column prop="fileName" label="附件内容" align="center">
          </el-table-column>
          <el-table-column label="附件地址" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.filePath" target="_blank">
                <div v-if="scope.row.filePath" class="pointer">点此预览</div>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="diaryBox" v-if="activeIndex == '3'">
        <el-button type="primary" style="
            display: block;
            margin-right: auto;
            width: 100px;
            margin-left: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          ">工作日志</el-button>
        <el-table :data="diaryData" border style="width: 95%; margin: 0 auto" highlight-current-row
          :header-cell-style="{ background: '#f7f7f7' }" max-height="460px">
          <el-table-column prop="createDt" label="时间" align="center" width="160">
          </el-table-column>
          <el-table-column prop="createorName" label="填写人" align="center" width="80">
          </el-table-column>
          <el-table-column label="内容" align="center">
            <template slot-scope="scope">
              <span style="white-space: pre-wrap;display: flex;text-align: left;width: 100%;">{{ scope.row.content }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="groupBox" v-if="activeIndex == '4'">
        <el-button type="primary" style="
            display: block;
            margin-right: auto;
            width: 100px;
            margin-left: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          ">项目组成员</el-button>
        <el-table :data="groupData" border style="width: 95%; margin: 0 auto" highlight-current-row
          :header-cell-style="{ background: '#f7f7f7' }">
          <el-table-column prop="nodeName" label="节点名称" align="center">
          </el-table-column>
          <el-table-column prop="nodeMemberName" label="成员名称" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="moneyBox" v-if="activeIndex == '5'">
        <div v-if="isZHZX === '1'">
          <div class="onebasic" style="position: relative">
            <el-row>
              <el-col :span="8">
                <div>合同金额：{{ basicInfor.projectAmount }}</div>
              </el-col>
              <el-col :span="8">
                <div>已付金额：{{ basicInfor.payAmount }}</div>
              </el-col>
              <el-col :span="8">
                <div>剩余金额：{{ basicInfor.surplusAmount }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>已付期数：{{ basicInfor.payPeriods }}</div>
              </el-col>
              <el-col :span="8">
                <div>剩余期数：{{ basicInfor.surplusPeriods }}</div>
              </el-col>
              <el-col :span="8">
                <div>剩余居间费：{{ basicInfor.surplusInteFee }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>总居间费：{{ basicInfor.totalInteFee }}</div>
              </el-col>
              <el-col :span="8">
                <div>已付居间费：{{ basicInfor.paidInteFee }}</div>
              </el-col>
            </el-row>
            <div class="editbtn" style="position: absolute; right: 10px; top: 20px" @click="editMoney">
              <i class="el-icon-edit" style="color: #1d9fff; font-size: 20px"></i>
            </div>
          </div>
          <div class="moneyplan">
            <el-button type="primary" style="
                display: block;
                margin-right: auto;
                width: 100px;
                margin-left: 20px;
                margin-top: 20px;
                margin-bottom: 20px;
              ">回款计划</el-button>
            <el-table :data="moneyplanData" border style="width: 95%; margin: 0 auto" highlight-current-row
              :header-cell-style="{ background: '#f7f7f7' }">
              <el-table-column prop="paymentTime" label="付款时间" align="center">
              </el-table-column>
              <el-table-column prop="paymentName" label="付款期数" align="center">
              </el-table-column>
            </el-table>
          </div>
          <div class="moneyRecord">
            <el-button type="primary" style="
                display: block;
                margin-right: auto;
                width: 100px;
                margin-left: 20px;
                margin-top: 20px;
                margin-bottom: 20px;
              ">回款记录</el-button>
            <el-table :data="moneyRecordData" border style="width: 95%; margin: 0 auto" highlight-current-row
              :header-cell-style="{ background: '#f7f7f7' }">
              <el-table-column prop="createDt" label="付款时间" align="center">
              </el-table-column>
              <el-table-column prop="payTimes" label="付款期数" align="center">
              </el-table-column>
              <el-table-column prop="payType" label="付款方式" align="center">
              </el-table-column>
              <el-table-column prop="payAmount" label="付款金额" align="center">
              </el-table-column>
              <el-table-column prop="surplusAmount" label="剩余金额" align="center">
              </el-table-column>
              <el-table-column prop="remark" label="备注" align="center">
              </el-table-column>
            </el-table>
          </div>
          <div class="moneyRecord">
            <el-button type="primary" style="
                display: block;
                margin-right: auto;
                width: 100px;
                margin-left: 20px;
                margin-top: 20px;
                margin-bottom: 20px;
              ">居间费记录</el-button>
            <el-table :data="middlemoneyRecordData" border style="width: 95%; margin: 0 auto" highlight-current-row
              :header-cell-style="{ background: '#f7f7f7' }">
              <el-table-column prop="createDt" label="付款时间" align="center">
              </el-table-column>
              <el-table-column prop="payTimes" label="付款期数" align="center">
              </el-table-column>
              <el-table-column prop="payType" label="付款方式" align="center">
              </el-table-column>
              <el-table-column prop="payAmount" label="付款金额" align="center">
              </el-table-column>
              <el-table-column prop="surplusAmount" label="剩余金额" align="center">
              </el-table-column>
              <el-table-column prop="remark" label="备注" align="center">
              </el-table-column>
            </el-table>
          </div>
          <!-- 回款记录修改小弹窗 -->
          <el-dialog title="修改: " :visible.sync="dialogEditform" style="width: 50%; margin: 0 auto" center
            append-to-body>
            <el-form :inline="true" :model="basicInfor" label-position="right" label-width="150px">
              <el-col :span="24">
                <el-form-item label="合同金额： ">
                  <el-input v-model="basicInfor.projectAmount"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="已付金额： ">
                  <el-input v-model="basicInfor.payAmount"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="剩余金额： ">
                  <el-input v-model="basicInfor.surplusAmount"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="总居间费： ">
                  <el-input v-model="basicInfor.totalInteFee"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="已付居间费： ">
                  <el-input v-model="basicInfor.paidInteFee"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="剩余居间费：">
                  <el-input v-model="basicInfor.surplusInteFee"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
            <div class="twobtn" style="width: 80%; margin: 20px auto; text-align: center">
              <el-button type="primary" style="margin-right: 20px" @click="editMoneyConfirm">确认</el-button>
              <el-button @click="dialogEditform = false">取消</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="complaintBox" v-if="activeIndex == '6'">
        <el-button type="primary" style="
            display: block;
            margin-right: auto;
            width: 100px;
            margin-left: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          ">投诉记录</el-button>
        <el-table :data="complaintData" border style="width: 95%; margin: 0 auto" highlight-current-row
          :header-cell-style="{ background: '#f7f7f7' }">
          <el-table-column prop="createDt" label="投诉时间" align="center">
          </el-table-column>
          <el-table-column prop="respondentName" label="被投诉人" align="center">
          </el-table-column>
          <el-table-column prop="complaintTitle" label="投诉标题" align="center">
          </el-table-column>
          <el-table-column prop="complaintContent" label="投诉内容" align="center">
          </el-table-column>
          <el-table-column prop="dealTime" label="处理时间" align="center">
          </el-table-column>
          <el-table-column prop="dealContent" label="处理反馈" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="noteBox" v-if="activeIndex == '7'">
        <el-button type="primary" style="
            display: block;
            margin-right: auto;
            width: 100px;
            margin-left: 20px;
            margin-top: 0 20px;
            margin-bottom: 20px;
          ">备注</el-button>
        <div style="
            width: 100%;
            margin: 0 auto;
            padding: 20px;
            box-sizing: border-box;
          ">
          <el-input type="textarea" :rows="3" v-model="notetext"> </el-input>
        </div>
        <el-button type="primary" style="display: block; margin: 0 auto; margin-top: 20px"
          @click="submitNote">提交</el-button>
      </div>
      <div class="groupBox" v-if="activeIndex == '8'">
        <el-button type="primary" style="
            display: block;
            margin-right: auto;
            width: 120px;
            margin-left: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          " @click="dialogMeeting = true">添加会议纪要</el-button>
        <el-table :data="meetingData" border style="width: 95%; margin: 0 auto" highlight-current-row
          :header-cell-style="{ background: '#f7f7f7' }">
          <el-table-column prop="createDt" label="日期" align="center">
          </el-table-column>
          <el-table-column prop="content" label="内容" align="center">
          </el-table-column>
        </el-table>
        <!-- 小弹窗 -->
        <el-dialog title="添加会议纪要: " :visible.sync="dialogMeeting" style="width: 50%; margin: 0 auto" center
          append-to-body>
          <el-form :inline="true" :model="addMeetingForm">
            <el-input type="textarea" v-model="addMeetingForm.content"></el-input>
          </el-form>
          <div class="twobtn" style="width: 80%; margin: 20px auto; text-align: center">
            <el-button type="primary" style="margin-right: 20px" @click="addMeetingPoint">确认</el-button>
            <el-button @click="dialogMeeting = false">取消</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="planBox" v-if="activeIndex == '9'">
        <el-button type="primary" style="
            display: block;
            margin-right: auto;
            width: 100px;
            margin-left: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          ">项目进度</el-button>
        <div style="width: 800px; margin: 0 auto">
          <el-input type="textarea" :rows="3" v-model="plantext"> </el-input>
        </div>

        <el-button type="primary" style="display: block; margin: 0 auto; margin-top: 20px"
          @click="submitPlan">提交</el-button>
      </div>
      <el-button type="primary" style="
          display: block;
          margin-left: auto;
          margin-right: 20px;
          margin-top: 20px;
        " @click="closeForm">关闭</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,//，默认不加载
      height: window.innerHeight - 180, //表格高度
      //顶部搜索
      searchInput: {
        projectName: "",
        startDate: "",
        endDate: "",
      },
      tableData: [],
      dialogFormVisible: false, //大弹窗
      dialogEditform: false,
      tabList: [
        "基本信息",
        "项目节点",
        "项目附件",
        "工作日志",
        "项目成员",
        "回款记录",
        "客户投诉",
        "备注",
        "会议纪要",
        "进度",
      ],
      activeIndex: 0,
      projectCode: "", //双击选中的项目
      projectId: "",
      // 基本信息
      basicInfor: {},
      // 项目节点
      activenum: null, //当前项目节点
      stepsList: [],
      fileData: [], // 项目附件
      diaryData: [], // 工作日志
      groupData: [], // 项目组成员
      complaintData: [], // 投诉记录
      meetingData: [], //会议纪要
      dialogMeeting: false, //添加会议纪要弹窗
      addMeetingForm: {
        content: "",
      },
      moneyplanData: [], //回款计划
      moneyRecordData: [], //回款记录
      middlemoneyRecordData: [], //居间费记录
      editForm: { money: "20" },
      notetext: "",
      plantext: "",
      // 分页查询
      total: 0,
      currentPage: 1,
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 300,
        //查询条件
        condition: {},
      },
      visible: false,
      top: 0,
      left: 0,
      currRow: {},
      isZHZX: "0",
    };
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 关闭右击菜单
    closeMenu() {
      this.visible = false;
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    //顶部搜索
    search() {
      this.queryInfo.condition.projectName = this.searchInput.projectName;
      this.queryInfo.condition.startDate = this.searchInput.startDate;
      this.queryInfo.condition.endDate = this.searchInput.endDate;
      this.queryInfo.condition.customerName = this.searchInput.customerName;
      this.getListData();
    },
     // 金额格式化：千分位逗号，保留2位小数
  formatMoney(num) {
    if (!num && num !== 0) return 0
  // 先转整数，再加千分位
  let n = Math.round(Number(num))
  return n.toString().replace(/\B(?=(\d{3})+$)/g, ',')
  },
      //计算未支付完成项目
    checkProject() {
      this.loading = true
      var that=this;
      try {
      this.$http
        .post("/project/checkProjectPaidInfo", this.queryInfo)
        .then(function (response) {
          //计算完成
          that.loading = false
        });
      } finally {
      // 2. 结束 → 关闭loading（无论成功失败都会关）
   
      }
    },
       //查询未支付完成项目
   queryUnPaidProject() {
      var that=this;
      try {
      this.$http
        .post("/project/queryPaymentProjectList", that.queryInfo)
        .then(function (response) {
          console.log("unpaid列表===>", response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            for (let i = 0; i < that.tableData.length; i++) {
              that.tableData[i].projectApprovalTime = that
                .timeFormate(response.data.data.data[i].projectApprovalTime)
                .substr(0, 10);
              that.tableData[i].conclusionTime = that
                .timeFormate(response.data.data.data[i].conclusionTime)
                .substr(0, 10);
            }
          }
        });
      } finally {
      // 2. 结束 → 关闭loading（无论成功失败都会关）
   
      }
    },
    // 获取列表
    getListData() {
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/project/list", that.queryInfo)
        .then(function (response) {
          console.log("列表===>", response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            for (let i = 0; i < that.tableData.length; i++) {
              that.tableData[i].projectApprovalTime = that
                .timeFormate(response.data.data.data[i].projectApprovalTime)
                .substr(0, 10);
              that.tableData[i].conclusionTime = that
                .timeFormate(response.data.data.data[i].conclusionTime)
                .substr(0, 10);
            }
          }
        });
    },
    // 双击某一行
    rowDblclick(row) {
      this.dialogFormVisible = true;
      this.basicInfor = row;
      this.projectCode = row.projectCode;
      this.projectName = row.projectName;
      this.projectStatus = row.projectStatus;
      this.projectId = row.id;
      console.log("当前选中行==>", row);
    },

    // 右击菜单
    openMenu(row, column, e) {
      console.log("^^^^", row);
      e.preventDefault();
      this.currRow = row;
      let x = e.pageX;
      let y = e.pageY;
      this.top = y;
      this.left = x;
      this.visible = true;
    },
    // 修改客户颜色
    changeColor(status, color) {
      console.log("this.currRow", this.currRow);
      let sendData = {};
      sendData.projectCode = this.currRow.projectCode;
      sendData.status = status;
      sendData.projectColor = color;
      this.$http.post("/project/update", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.getListData();
          this.visible = false;
        }
      });
    },
    // 小圆点修改颜色
    changeColor1(color) {
      console.log("this.currRow", this.currRow);
      let sendData = {};
      sendData.projectCode = this.currRow.projectCode;
      sendData.status = this.currRow.status;
      sendData.projectColor = color;
      this.$http.post("/project/update", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.getListData();
          this.visible = false;
        }
      });
    },
    // 更改选中行背景色
    rowStyle({ row, rowIndex }) {
      return { "background-color": row.projectColor };
    },

    // 点击切换栏目
    changeTap(e) {
      this.activeIndex = e.currentTarget.dataset.index;
      if (this.activeIndex == 1) {
        this.loadNode();
      } else if (this.activeIndex == 2) {
        this.loadFile();
      } else if (this.activeIndex == 3) {
        this.loadDiary();
      } else if (this.activeIndex == 4) {
        this.loadGroupmember();
      } else if (this.activeIndex == 5) {
        this.loadBackmoney();
      } else if (this.activeIndex == 6) {
        this.loadComplaint();
      } else if (this.activeIndex == 7) {
        this.queryNote();
      } else if (this.activeIndex == 8) {
        this.loadMeetingPoint();
      } else if (this.activeIndex == 9) {
        this.queryPlan();
      }
    },
    // 关闭弹窗
    closeForm() {
      this.dialogFormVisible = false;
      this.activeIndex = 0;
      // this.getListData()
    },
    closeBigDialog() {
      this.activeIndex = 0;
      this.getListData();
    },
    // 项目节点
    loadNode() {
      var that = this;
      let data = {};
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      data.projectCode = that.projectCode;
      that.$http.post("projectNodes/queryList", data).then(function (response) {
        console.log("项目节点===>", response.data.data);
        if (response.data.code == 200) {
          that.stepsList = response.data.data;
          for (let i = 0; i < response.data.data.length; i++) {
            that.stepsList[i].expectFinishTime = response.data.data[
              i
            ].expectFinishTime.slice(0, 11);
            if ((that.stepsList[i].nodeStatus = "4")) {
              that.activenum += 1;
            }
          }
        }
      });
    },
    // 项目附件
    loadFile() {
      var that = this;
      let data = {};
      data.projectCode = that.projectCode;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("/project/loadBelongsInfo", data)
        .then(function (response) {
          console.log("项目附件===>", response.data.data);
          if (response.data.code == 200) {
            that.fileData = response.data.data;
          }
        });
    },
    // 预览附件
    showFile(row) { },
    //  工作日志
    loadDiary() {
      var that = this;
      let data = {};
      data.projectCode = that.projectCode;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("projectNodesLog/queryList", data)
        .then(function (response) {
          console.log("工作日志===>", response.data.data);
          if (response.data.code == 200) {
            let diaryData = response.data.data;

            for (let i = 0; i < diaryData.length; i++) {
              let diaryItem = diaryData[i];
              diaryItem.createDt = that.timeFormate(
                diaryData[i].createDt
              );

              diaryItem.content.replace(/\n/g, '<br>')
            }

            that.diaryData = diaryData;
          }
        });
    },
    // 项目成员
    loadGroupmember() {
      var that = this;
      let data = {};
      data.projectCode = that.projectCode;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("projectNodesMember/queryList", data)
        .then(function (response) {
          console.log("项目成员===>", response.data.data);
          if (response.data.code == 200) {
            that.groupData = response.data.data;
          }
        });
    },
    // 回款
    loadBackmoney() {
      var that = this;
      let data = {};
      data.projectCode = that.projectCode;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("/project/loadPaymentInfo", data)
        .then(function (response) {
          console.log("回款===>", response.data.data);
          if (response.data.code === 200) {
            // 回款计划
            that.moneyplanData = response.data.data.projectPaymentPlanList;
            for (
              let i = 0;
              i < response.data.data.projectPaymentPlanList.length;
              i++
            ) {
              that.moneyplanData[i].paymentTime = that.timeFormate(
                response.data.data.projectPaymentPlanList[i].paymentTime
              );
            }
            // 回款记录
            that.moneyRecordData = response.data.data.paymentReceivableList;
            for (
              let i = 0;
              i < response.data.data.paymentReceivableList.length;
              i++
            ) {
              that.moneyRecordData[i].createDt = that.timeFormate(
                response.data.data.paymentReceivableList[i].createDt
              );
              if (that.moneyRecordData[i].payType == '1') {
                response.data.data.paymentReceivableList[i].payType = '微信'
              } else if (that.moneyRecordData[i].payType == '2') {
                response.data.data.paymentReceivableList[i].payType = '支付宝'
              } else if (that.moneyRecordData[i].payType == '3') {
                response.data.data.paymentReceivableList[i].payType = '对公打款'
              }
            }
            // 居间费记录
            that.middlemoneyRecordData =
              response.data.data.paymentReceivableInteFeeList;
            for (
              let i = 0;
              i < response.data.data.paymentReceivableInteFeeList.length;
              i++
            ) {
              that.middlemoneyRecordData[i].createDt = that.timeFormate(
                response.data.data.paymentReceivableInteFeeList[i].createDt
              );
              if (that.middlemoneyRecordData[i].payType == '1') {
                response.data.data.paymentReceivableInteFeeList[i].payType = '微信'
              } else if (that.middlemoneyRecordData[i].payType == '2') {
                response.data.data.paymentReceivableInteFeeList[i].payType = '支付宝'
              } else if (that.middlemoneyRecordData[i].payType == '3') {
                response.data.data.paymentReceivableInteFeeList[i].payType = '对公打款'
              }
            }
            // 判断是否是指挥中心
            that.isZHZX = "1";
          } else {
            that.isZHZX = "0";
            that.$message({
              message: "权限不足",
              type: "error",
            });
          }
        });
    },
    // 编辑回款记录
    editMoney() {
      this.dialogEditform = true;
    },
    // 编辑确认
    editMoneyConfirm() {
      this.basicInfor.projectCode = this.projectCode;
      this.$http.post("/project/update", this.basicInfor).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.$notify.success({
            title: "提示",
            message: "修改成功",
            showClose: true,
          });
          this.dialogEditform = false;
        } else {
          this.$notify.error({
            title: "提示",
            message: res.data.message,
            showClose: true,
          });
        }
      });
    },
    //客户投诉
    loadComplaint() {
      var that = this;
      let data = {};
      data.projectCode = that.projectCode;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("projectComplaint/queryList ", data)
        .then(function (response) {
          console.log("客户投诉===>", response.data.data);
          if (response.data.code == 200) {
            that.complaintData = response.data.data;
            for (let i = 0; i < response.data.data.length; i++) {
              that.complaintData[i].createDt = that.timeFormate(
                response.data.data[i].createDt
              );
            }
          }
        });
    },
    // 获取备注与提交备注
    queryNote() {
      var that = this;
      let data = {};
      data.id = that.projectId;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http.post("project/queryOne", data).then(function (response) {
        console.log("获取备注===>", response.data.data);
        if (response.data.code == 200) {
          that.notetext = response.data.data.remark;
        }
      });
    },
    submitNote() {
      var that = this;
      let data = {};
      data.id = that.projectId;
      data.remark = that.notetext;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http.post("project/update", data).then(function (response) {
        console.log("提交进度===>", response.data.data);
        if (response.data.code == 200) {
          that.$message({
            message: "提交成功",
            type: "success",
          });
          that.queryNote();
        }
      });
    },
    // 会议纪要
    loadMeetingPoint() {
      var that = this;
      let data = {};
      data.projectCode = that.projectCode;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("meetingSummary/queryList", data)
        .then(function (response) {
          console.log("会议纪要===>", response.data.data);
          if (response.data.code == 200) {
            that.meetingData = response.data.data;
            for (let i = 0; i < response.data.data.length; i++) {
              that.meetingData[i].createDt = that.timeFormate(
                response.data.data[i].createDt
              );
            }
          }
        });
    },
    addMeetingPoint() {
      var that = this;
      let data = {};
      data.projectCode = that.projectCode;
      data.projectName = that.projectName;
      data.status = that.projectStatus;
      data.createCode = localStorage.getItem("userName");
      data.createName = localStorage.getItem("name");
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      data.content = that.addMeetingForm.content;
      // console.log("senddata==>", data);
      that.$http.post("meetingSummary/save", data).then(function (response) {
        if (response.data.code == 200) {
          that.$message({
            message: "提交成功",
            type: "success",
          });
          that.queryPlan();
          that.loadMeetingPoint();
          that.dialogMeeting = false;
          that.addMeetingForm.content = "";
        }
      });
    },
    // 获取与提交进度
    queryPlan() {
      var that = this;
      let data = {};
      data.id = that.projectId;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http.post("project/queryOne", data).then(function (response) {
        console.log("获取进度===>", response.data.data);
        if (response.data.code == 200) {
          that.plantext = response.data.data.speed;
        }
      });
    },
    submitPlan() {
      var that = this;
      let data = {};
      data.id = that.projectId;
      data.speed = that.plantext;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http.post("project/update", data).then(function (response) {
        console.log("提交进度===>", response.data.data);
        if (response.data.code == 200) {
          that.$message({
            message: "提交成功",
            type: "success",
          });
          that.queryPlan();
        }
      });
    },
    // 时间格式化
    timeFormate(originVal) {
      const dt = new Date(originVal);

      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      // yyyy-mm-dd hh:mm:ss
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
  },
  created() {
    this.getListData();
    window.addEventListener("resize", this.getHeight);
    var that = this;
    document.onkeydown = function (e) {   //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        that.getListData();
      }
    };
  },
};
</script>

<style lang="less" scoped>
.contain {
  padding: 0 20px;
  box-sizing: border-box;



  .activebg {
    background-color: #fff;
  }

  .tabbox {
    height: 40px;
    line-height: 40px;
    background-color: #f7f7f7;
    margin-bottom: 10px;

    .onetab {
      width: 70px;
      text-align: center;
    }
  }
 
  .tabbox:hover {
    cursor: pointer;
  }

  .input-placeholder-sm::placeholder {
      font-size: 8px !important;
    }
  .pointer:hover {
    cursor: pointer;
  }

  /deep/.el-dialog {
    padding-bottom: 30px;
  }

  /deep/.el-dialog__body {
    line-height: 20px;
    padding-top: 10px !important;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 5px !important;
  }

  // .基本信息
  .onebasic {
    width: 95%;
    background-color: #f7f7f7;
    margin: 0 auto;
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // 项目节点的额时间
  /deep/.el-step__title.is-finish {
    color: #1e1e1e;
    font-weight: 700;
  }

  /deep/.el-step__description.is-finish {
    color: #1e1e1e;
  }

  .contextmenu {
    width: 150px;
    margin: 0;
    z-index: 3000;
    position: fixed;
    list-style-type: none;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    background-color: #efefef;

    .cusBox {
      cursor: pointer;
      padding: 5px 15px;
      border-bottom: 1px solid #ccc;
    }

    .color-box {
      cursor: pointer;
      height: 12px;
      width: 12px;
      border-radius: 50%;
      margin-right: 5px;
    }
  }

  .noteBox {
    width: 100%;

    /deep/.el-textarea {
      width: 100%;
    }

    /deep/.el-textarea__inner {
      width: 100%;
    }
  }

  /deep/.el-table tbody tr:hover>td {
    background-color: transparent !important;
  }
}
</style>
